export const PlainText = (text)=>({
        Content: text,
        MarkUp: 'plaintext'
    });
export const Html = (html)=>({
        Content: html,
        MarkUp: 'html'
    });
